import i18next from "i18next";
import a11yMiddleware from "./a11y-middleware/middleware";
import actionDecoratorMiddlewareFactory from "./action-decorator/middlewareFactory";
import actionTransformerMiddleware from "./action-transformer/middleware";
import aiAssistantmiddleware from "./ai-assistant/middleware";
import configMiddleware from "./config/configMiddleware";
import detailLevelMiddleware from "./detail-level-middleware/middleware";
import externalServiceRedirectMiddleware from "./external-service-redirect-middleware/middleware";
import fetchStructureHandlerMiddleware from "./fetch-structure-handler/middleware";
import fileSaveMiddleware from "./file-save/middleware";
import i18nMiddleware from "./i18n-middleware/middleware";
import miscellaneousMiddleware from "./miscellaneous/middleware";
import moduleConfigsMiddlewareFactory from "./module-configs/middlewareFactory";
import multiViewerPlusMiddleware from "./multi-viewer-plus/middleware";
import multiViewerMiddlewareFactory from "./multi-viewer/middlewareFactory";
import nodeMiddleware from "./node/middleware";
import middlewarePackageManager from "./package-manager/middleware";
import persistenceMiddleware from "./persistence/middleware";
import requestSpinnerMiddlewareFactory from "./request-spinner/requestSpinnerMiddlewareFactory";
import requestMiddlewareFactory from "./request/requestMiddlewareFactory";
import singleViewerMiddlewareFactory from "./single-viewer/middlewareFactory";
import userMiddlewareFactory from "./user/userMiddlewareFactory";

const t = i18next.t.bind(i18next);

const middlewareList = [
  actionDecoratorMiddlewareFactory(t),
  actionTransformerMiddleware,
  i18nMiddleware,
  userMiddlewareFactory(t),
  externalServiceRedirectMiddleware,
  requestMiddlewareFactory(t),
  requestSpinnerMiddlewareFactory(t),
  fileSaveMiddleware,
  persistenceMiddleware,
  a11yMiddleware,
  detailLevelMiddleware,
  configMiddleware,
  nodeMiddleware,
  fetchStructureHandlerMiddleware,
  singleViewerMiddlewareFactory(t),
  multiViewerMiddlewareFactory(t),
  multiViewerPlusMiddleware,
  moduleConfigsMiddlewareFactory(t),
  miscellaneousMiddleware,
  middlewarePackageManager,
  aiAssistantmiddleware
];

export default middlewareList;
